import { Link } from "react-router-dom";

export default function OutOfJokesScreen({ onPlayAgain }) {
  return (
    <div id='out_of_jokes'>
      <div id='out_of_jokes_banner'>🎉</div>
      <h2 id='out_of_jokes_title'>You're Done!</h2>
      <p id='out_of_jokes_subtitle'>You solved every joke we've got. Nicely played.</p>
      <button id='play_again' onClick={onPlayAgain}>Play Again 🔁</button>
      <Link to="/humor-quiz" id='out_of_jokes_quiz_link'>Curious what your humor style is? Take the quiz →</Link>
    </div>
  );
}
